<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
<p-toast></p-toast>
<p-fieldset>


    <ng-template pTemplate="header">INVENTORY ADJUSTMENTS</ng-template>


    <div class="p-grid">
        <div class="p-col-12 p-md-6">
            <div class="card">
                <div class="p-fluid">
                    <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">

                        <label for="opt">{{lbl_zone}}</label>
                        <div class="p-col-12 p-md-10">
                            <p-dropdown [options]="listZones" [(ngModel)]="selectedZone" optionLabel="descri"
                                [showClear]="true" placeholder="{{lbl_select}} {{lbl_zone}}"
                                (onChange)="loadNatios($event)"></p-dropdown>
                        </div>
                    </div>
                    <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                        <label for="opt">{{lbl_natio}}</label>
                        <div class="p-col-12 p-md-10">
                            <p-dropdown [options]="listNatio" [(ngModel)]="selectedNatio" optionLabel="descri"
                                [showClear]="true" placeholder="{{lbl_select}} {{lbl_natio}}"
                                (onChange)="loadCountrys($event)"></p-dropdown>
                        </div>
                    </div>                    
                </div>
            </div>
            <div class="p-field">
                <button pButton pRipple label="{{lbl_search}}" icon="pi pi-plus" class="p-button-info p-mr-2"
                    (click)="search()"></button>
            </div>
        </div>
    </div>


    <p-table #dt [value]="listInvItems" [rows]="10" [paginator]="true" [globalFilterFields]="['itemId','qty']"
        [rowHover]="true" dataKey="itemId" styleClass="p-datatable-customers"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [showCurrentPageReport]="true">
        <ng-template pTemplate="caption">
            <div class="p-d-flex p-ai-center p-jc-between">
                <h5 class="p-m-0">items </h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="{{lbl_search}}..." />
                </span>
            </div>

            <span class="p-input-icon-left">


                <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()"
                    class="p-button-success p-mr-2" pTooltip="XLS" tooltipPosition="bottom"></button>
                <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()"
                    class="p-button-warning p-mr-2" pTooltip="PDF" tooltipPosition="bottom"></button>
            </span>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>

                <th pSortableColumn="itemId">Item Id<p-sortIcon field="itemId"></p-sortIcon></th>
                <th pSortableColumn="qty">Cantidad<p-sortIcon field="qty"></p-sortIcon></th>
                <th pSortableColumn="avgCost">Costo promedio<p-sortIcon field="avgCost"></p-sortIcon></th>

            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-itm>
            <tr>
                <td>{{itm.id.itemId}}</td>
                <td>{{itm.qty}}</td>
                <td>{{itm.avgCost}}</td>

            </tr>
        </ng-template>

        <ng-template pTemplate="summary">
            <div class="flex align-items-center justify-content-between">
                {{lbl_total}} {{lbl_there_are}} {{listInvItems ? listInvItems.length : 0 }} Items.
            </div>
        </ng-template>
    </p-table>



</p-fieldset>